<!--  -->
<template>
  <div class="footerBox">
    <div class="footer">
      <ul class="footer_text">
        <li>关于我们 <a href="/#/certificate">&nbsp; &nbsp;证书查询 </a></li>
        <li v-if="contact_number">联系电话：{{ contact_number }}</li>
        <li v-if="company_address||postcode">
          <a target="_blank">
            <span v-if="company_address">公司地址：{{ company_address }}</span>
            <span v-if="postcode">邮编：{{ postcode }}</span>
          </a>
        </li>
        <li v-if="copyright">
          <a href="http://ahharc.com/">版权所有：{{ copyright }}</a>
        </li>
        <li v-if="website_record_number">
          <a> 备 案 号 ：{{ website_record_number }}</a>
        </li>
      </ul>
      <div v-if="logoSrc" class="footer_img qrcode">
        <vue-qr
          :logo-src="logoSrc"
          :size="186"
          :margin="0"
          :auto-color="true"
          :dot-scale="1"
          :text="qr_code"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VueQr from "vue-qr";

export default {
  data() {
    return {
      contact_number: "",
      company_address: "",
      copyright: "",
      website_record_number: "",
      postcode: "",
      qr_code: "",
      logoSrc: require("../assets/img/logo01.png"),
    };
  },

  components: {
    VueQr,
  },

  computed: {},

  mounted() {
    this.getSetting();
  },

  methods: {
    getSetting() {
      let _this = this;
      _this.request("api/index/setting", {}, "get").then((res) => {
        if (res.data.status == "success") {
          let settingData = res.data.data.index_setting;
          _this.contact_number = settingData.contact_number;
          _this.company_address = settingData.company_address;
          _this.copyright = settingData.copyright;
          _this.website_record_number = settingData.website_record_number;
          _this.postcode = settingData.postcode;
          _this.qr_code = settingData.qr_code;
        }
      });
    },
  },
};
</script>
<style lang='less' scoped>
  .footerBox{
    background-color: #1b1b1b;
}
.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /*height: 2.73rem;*/
  padding: 10px 0px;
  .footer_text {
    display: flex;
    flex-direction: column;
    margin-left: 0.72rem;
    li {
      color: #fff;
      /*line-height: 0.42rem;*/
      a {
        color: #fff;
      }
    }
  }
  @media screen and (min-width: 480px) {
    .footer_text li{

      font-weight: 100!important;
      font-family: "Arial";
      font-size: 0.24rem;
      line-height: 0.45rem;
    }
    .footer_img {
      width: 1.86rem;
      margin-right: 0.76rem;
      img {
        width: 100%;
      }
    }
  }
  @media screen and (max-width: 480px) {
    .footer_img {
      /*width: 2.73rem;*/
      margin-right: 10px;
      img {
        width: 100%;
      }
    }
    .footer_text li{
      font-size: 12px;
      font-weight: 100;
    }
  }

}

.qrcode {
  display: inline-block;
  img {
    background-color: #fff; //设置白色背景色
    padding: 6px; // 利用padding的特性，挤出白边
    box-sizing: border-box;
  }
}
</style>
